import Footer from "./Footer"
import Header from "./Header"

const Layout = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={className}>
      <Header />
      {children}
      <Footer />
    </div>
  )
}

export default Layout
